import './sections.scss';
function Video() {
return (
    <div className='video'>
       <iframe width="100%" height="660" src="https://www.youtube.com/embed/P9FiY0xd7kU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
)}
export default Video;